export const initStateUser= (
   Object.assign({
      data        : [],
      list_users  : [],
      displayName : '',
      email       : '',
      password    : '',
      actionForm  : false,
      visible_current_password : "off",
      visible_new_password     : "off",
      current_password         : "",
      new_password             : "",
      list_permits             : [],
      without_permission       : true
   })
);